import { render } from "./ItemsList.vue?vue&type=template&id=546f0ce0&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"

import "./ItemsList.vue?vue&type=style&index=0&id=546f0ce0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546f0ce0"]])

export default __exports__